import {
  CHARACTER_MATCH_ARRAY_OPTIONS,
  CHARACTER_MATCH_OPTIONS,
  IMatchModeOptionsType,
  MatchMode,
  VERSION_MATCH_OPTIONS,
} from '@/presentation/components/form/standards/types';

/** 字段 key → 该字段在表单中使用的匹配模式选项（与表单 modeOptions 同源） */
export type FieldModeOptionsMap = Record<string, IMatchModeOptionsType[]>;

const DEFAULT_MODE_OPTIONS = CHARACTER_MATCH_OPTIONS;

/** 为空/不为空：无需值的匹配模式，仅展示模式标签 */
const NO_VALUE_MODES = new Set<string>([MatchMode.ISEMPTY, MatchMode.NOTEMPTY]);
export const isEmptyMode = (mode: string | undefined): boolean => !!mode && NO_VALUE_MODES.has(mode);

/**
 * 按字段实际使用的匹配模式选项查找 mode 的展示标签，与表单保持一致。
 */
export const getMatchModeLabel = (
  mode: string,
  fieldModeOptions: FieldModeOptionsMap,
  key: string,
): string => {
  const opts = fieldModeOptions[key] ?? DEFAULT_MODE_OPTIONS;
  return opts.find(o => o.value === mode)?.label ?? mode;
};

export {
  CHARACTER_MATCH_ARRAY_OPTIONS,
  CHARACTER_MATCH_OPTIONS,
  VERSION_MATCH_OPTIONS,
};
